import { useSelector } from 'react-redux';
import { BookmarksDisplay } from '../components/shelves/BookmarksDisplay';
import { PublicYours } from '../components/shelves/PublicYours';
import { Yours } from '../components/shelves/Yours';

export function YoursPage() {
  const { status } = useSelector((state) => state.auth);
  const authenticated = status === 'authenticated';

  return (
    <section className="container mx-auto mt-8 mb-16 max-w-[600px] break-words px-2 2xl:max-w-2xl">
      {authenticated ? <Yours /> : <PublicYours />}
      <div className="w-full">
        <h3 className="text-lg">Saved Threads</h3>
        <BookmarksDisplay />
      </div>
    </section>
  );
}
